import { App } from 'vue';
import moment from 'moment';

// Declare the global property type for TypeScript
declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$moment: typeof moment;
	}
}

// Create a plugin to install Moment.js
export default {
	install(app: App) {
		app.config.globalProperties.$moment = moment;
	},
};
